/* global axios */
/* eslint-disable */
import ApiClient from './ApiClient';

class TicketsAPI extends ApiClient {
  constructor() {
    super('tickets', { accountScoped: true, apiVersion: 'v1' });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(ticketNumber) {
    return axios.get(`${this.url}/${ticketNumber}`);
  }

  update(ticketNumber, data) {
    return axios.patch(`${this.url}/${ticketNumber}`, { ticket: data });
  }

  transition(ticketNumber, data) {
    return axios.post(`${this.url}/${ticketNumber}/transition`, { ticket: data });
  }

  assign(ticketNumber, data) {
    return axios.post(`${this.url}/${ticketNumber}/assign`, { ticket: data });
  }

  counts() {
    return axios.get(`${this.url}/counts`);
  }

  convert(conversationId, data) {
    return axios.post(
      `${this.baseUrl()}/conversations/${conversationId}/ticket/conversion`,
      { ticket: data }
    );
  }

  showByConversation(conversationId) {
    return axios.get(`${this.baseUrl()}/conversations/${conversationId}/ticket`);
  }

  retryCustomerNotification(ticketNumber) {
    return axios.post(`${this.url}/${ticketNumber}/retry_customer_notification`);
  }
}

export default new TicketsAPI();
